import { render } from "./Question.vue?vue&type=template&id=34caaf04"
import script from "./Question.vue?vue&type=script&setup=true&lang=js"
export * from "./Question.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/question/Question.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34caaf04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34caaf04', __exports__)) {
    api.reload('34caaf04', __exports__)
  }
  
  module.hot.accept("./Question.vue?vue&type=template&id=34caaf04", () => {
    api.rerender('34caaf04', render)
  })

}


export default __exports__